const Constants = {
    NEW_PRODUCT_LINE: " -- Select a product --",  // Drop down values when nothing is selected yet
    MAIN_SCHOOL: " -- "                           // Hidden drop down value for the default school
};

export default Constants;
